/** Map commands forwarded by the wrapper to the existing navigation owner. */
export const MAP_COMMANDS = Object.freeze(["applyMapBounds", "clearMapSelection", "setMapBoundsMode"]);
